import { Injectable } from '@angular/core';
import { Router,CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
		protected router : Router
	){}

  	canActivate(router,state:RouterStateSnapshot){
      console.log("guard");
		if(localStorage.getItem('_user')) 
			return true;

		this.router.navigate(['/']);
		return false;
	}
  
}
